import { RouteMeta } from 'vue-router';
import {
  Component, InjectReactive, Vue, Watch,
} from 'vue-property-decorator';
import styles from './breadcrumb.module.scss';
import WithRender from './breadcrumb.html';
// models
import { BreadCrumbModel } from '@/modules/shared/models/breadcrumb';
import { UserModel } from '@/modules/shared/models/user';
import { isEmptyObject } from '../../utils/global';

@WithRender
@Component
export default class BreadCrumb extends Vue {
  @InjectReactive()
  private userInfo!: UserModel;

  @InjectReactive()
  private isUserInfoLoading!: boolean;

  public styles = styles;
  public showBreadCrumb = false;

  public baseBreadcrumb: BreadCrumbModel[] = [];
  public breadcrumbs: BreadCrumbModel[] = [];

  public get isHighlighted() {
    const { path } = this.$route;
    const dynamicallyHighlightedFromRouter = this.getRouteMeta()?.highlighted || false;
    const highlightedRoutes: string[] = [];

    return highlightedRoutes.includes(path.toLocaleLowerCase()) || dynamicallyHighlightedFromRouter;
  }

  get isLoaggedIn(): boolean {
    return !isEmptyObject(this.userInfo);
  }

  async mounted() {
    this.appendDynamicBreadcrumbs();
  }

  public appendDynamicBreadcrumbs() {
    const requiredText = this.isLoaggedIn ? 'shared.dashboard' : 'shared.home';
    const requiredApp = this.isLoaggedIn ? 'dashboard' : 'landing';

    const initialBreadCrumbs = [
      {
        external: true,
        text: this.$t(requiredText) as string,
        href: `/applications/${requiredApp}`,
      },
    ];

    this.breadcrumbs = [...initialBreadCrumbs];
    this.baseBreadcrumb = [...initialBreadCrumbs];

    this.updateBreadCrumbs();
  }

  @Watch('$route')
  public updateBreadCrumbs() {
    this.showBreadCrumb = this.$route.fullPath !== '/';

    let enhancedBreadcrumbs: BreadCrumbModel[] = [...this.baseBreadcrumb];

    this.$route.matched.forEach((route) => {
      const enhancedMeta = this.getRouteMeta(route);

      const hasBreadcrumb = 'breadcrumb' in enhancedMeta;

      if (hasBreadcrumb) {
        enhancedBreadcrumbs = enhancedBreadcrumbs.concat(enhancedMeta.breadcrumb);
      } else {
        enhancedBreadcrumbs = [...this.baseBreadcrumb];
      }
    });

    // ? update [disabled/external] prop
    this.breadcrumbs = enhancedBreadcrumbs.map((route, index) => ({
      ...route,
      external: route.external || false,
      disabled: index === (enhancedBreadcrumbs.length - 1),
    }));
  }

  public getRouteMeta(route: RouteMeta = this.$route): RouteMeta {
    const { meta } = route;

    return typeof meta === 'function' ? meta(this.$route, this.isLoaggedIn) : meta;
  }

  public onClickBreadcrumb(route: BreadCrumbModel) {
    this.$router.push(route.href || '');
  }
}
